import { useQuery } from 'react-query';
import CompanyService from 'App/services/CompanyService';

function useFetchCompanyUsers(query) {
    return useQuery(['company', 'users', query], {
        queryFn: () => CompanyService.getCompanyUsers(query),
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });
}

export default useFetchCompanyUsers;
